<template lang="pug">
  v-dialog(
    :value="value"
    @input="updateValue"
    width="500"
    style="z-index: 9999"
  )
    v-card
      v-card-text
        div.d-flex.justify-center.py-4.gap-2
          v-btn(
            small
            :color="ratioMode === '16:9' ? 'primary' : 'grey'"
            @click="setRatio16x9"
          ) 16:9

          v-btn(
            small
            :color="ratioMode === 'custom' ? 'primary' : 'grey'"
            @click="setCustomRatio"
          ) Custom

        div.d-flex.flex-wrap.justify-center
          vueCropper(
            ref="cropper"
            :img="img"
            :info="true"
            :fixed="options.fixed"
            :fixed-number="currentRatio"
            :auto-crop="options.autoCrop"
            :center-box="options.centerBox"
            output-type="webp"
            :full="true"
            :info-true="true"
            :high="false"
            :output-size="0.8"
            :background="false"
          ).crop-area

        v-btn(
          block
          @click="cropImage"
          color="primary"
          :loading="processing"
          class="my-3"
        )
          v-icon.mr-2 mdi-crop
          span Crop image
</template>

<script>
import { VueCropper } from 'vue-cropper'

export default {

  components: {
    VueCropper,
  },

  props: {
    processing: {
      type: Boolean,
      default: false,
    },
    value: Boolean,
    image: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      file: null,
      img: '',
      ratioMode: '16:9', // '16:9' | 'custom'
      currentRatio: [16, 9],
      options: {
        autoCrop: true,
        centerBox: true,
        fixed: true,
      },
      cropperOptions: {
        centerBox: true,
        background: false,
      },
    }
  },

  watch: {
    image(val) {
      if (val) {
        this.setImageToCropArea(val)
      }
    },
  },

  methods: {
    updateValue(value) {
      this.$emit('input', value)
    },

    setRatio16x9() {
      this.ratioMode = '16:9'
      this.currentRatio = [16, 9]
      this.options.fixed = true

      this.$nextTick(() => {
        this.$refs.cropper?.refresh()
      })
    },

    setCustomRatio() {
      this.ratioMode = 'custom'
      this.options.fixed = false

      this.$nextTick(() => {
        this.$refs.cropper?.refresh()
      })
    },

    setImageToCropArea(file) {
      this.file = file
      const reader = new FileReader()

      reader.onload = (e) => {
        let data
        if (typeof e.target.result === 'object') {
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        this.img = data
      }

      reader.readAsArrayBuffer(file)
    },

    cropImage() {
      this.$refs.cropper.getCropBlob((pngBlob) => {
        if (!pngBlob) return;

        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;

          const ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, canvas.width, canvas.height);

          ctx.drawImage(img, 0, 0);

          canvas.toBlob((webpBlob) => {
            if (!webpBlob) return;

            const webpFile = new File([webpBlob], this.file.name.replace(/\.\w+$/, '.webp'), {
              type: 'image/webp',
            });

            this.$emit('onCrop', webpFile);
          }, 'image/webp');
        };
        img.onerror = () => {
          console.error('Failed to load PNG blob for conversion to WebP');
        };
        img.src = URL.createObjectURL(pngBlob);
      }, 'image/png');
    },
  },
}
</script>

<style lang="scss" scoped>
.crop-area {
  min-height: 400px;
}

.gap-2 {
  gap: 8px;
}
</style>
